import Swal from 'sweetalert2'
import { environment } from '../environment'
import { handleLogout } from './tool-service'
export const AlertType = {
    warning: 'warning',
    error: 'error',
    success: 'success',
    info: 'info',
    question: 'question'
}

export class AlertService {
    /**
     * 
     * @param {string} title 
     * @param {string} text 
     * @param {'success'|'info'|'question'|'warning'|'error'} type 
     * @param {*} html 
     */
    static ok(title = 'System Info', text = '', type = AlertType.warning, html) {
        return Swal.fire({
            title: title,
            heightAuto: false,
            text: text,
            icon: type,
            html: html,
            customClass: {
                confirmButton: 'btn'
            }
        })
    }
    // 按下ok後登出
    static async logout(title = 'System Info', text = '', type = AlertType.warning, html) {
        return Swal.fire({
            title: title,
            heightAuto: false,
            text: text,
            icon: type,
            html: html,
            customClass: {
                confirmButton: 'btn'
            }
        }).then(res => {
            if (res.isConfirmed) {
                handleLogout();
                // window.location.replace(`/${environment.contextPath}/${environment.contextVersion}/${environment.front}/login`)
            }else{
                handleLogout();
                // window.location.replace(`/${environment.contextPath}/${environment.contextVersion}/${environment.front}/login`)
            }
        })
    }

    /**
     * 
     * @param {Object} option 選項
     * @param {string} option.title 提示窗的標題 (大字)，預設為"Whether to continue"
     * @param {string} option.text 提示窗的內容或副標題 (小字)
     * @param {'success'|'info'|'question'|'warning'|'error'} option.type 提示窗的種類，預設為"question"
     * @param {string} option.confirmButtonText 確認按鈕要顯示的字，預設為"Confirm"
     * @param {string} option.cancelButtonText 取消按鈕要顯示的字，預設為"Cancel"
     * @param {boolean} option.showCancelButton 是否要有取消按鈕，true:要顯示，false:不顯示，預設為true
     * @param {function} option.preConfirm 確認按鈕按下後要執行的方法
     * @param {Object|string} option.customClass 按鈕的樣式
     * * Example:
     * ```
     * Swal.fire({
     *   customClass: {
     *     container: '...',
     *     popup: '...',
     *     title: '...',
     *     closeButton: '...',
     *     icon: '...',
     *     image: '...',
     *     input: '...',
     *     inputLabel: '...',
     *     validationMessage: '...',
     *     actions: '...',
     *     confirmButton: '...',
     *     denyButton: '...',
     *     cancelButton: '...',
     *     loader: '...',
     *     footer: '...',
     *     timerProgressBar: '...',
     *   }
     * })
     * ```
     * 
     * @param {any} option.html ?
     */
    static async ask({
        title = "Whether to continue",
        text = "",
        type = AlertType.question,
        confirmButtonText = "Confirm",
        cancelButtonText = "Cancel",
        showCancelButton = true,
        preConfirm = () => { console.error("Didn't set the function for preConfirm btn!") },
        customClass = {
            confirmButton: "btn",
            cancelButton: "btn"
        },
        html = undefined
    }) {
        return Swal.fire({
            title: title,
            text: html ? undefined : text,
            icon: type,
            heightAuto: false,
            customClass: { ...customClass },
            confirmButtonText: confirmButtonText,
            cancelButtonText: cancelButtonText,
            showCancelButton: showCancelButton,
            html: html || `<div style="white-space: pre-line;">${text}</div>`,
            preConfirm: preConfirm
        });
    }
}